
import { UserAuditEvent } from '../../model/user-audit-event.model';
import { TRANSFER_ASSET_METADATA } from './transfer-asset.metadata';
import { TransferAssetBase } from './transfer-asset.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface TransferAsset extends TransferAssetBase {
}

export interface TransferAssetTransient { }

export class TransferAsset extends CrudEntity<TransferAsset, number, TransferAssetTransient> implements TransferAssetTransient {
  constructor(source?: Partial<TransferAsset>, options?: CrudEntityConstructionOptions<TransferAsset, number, TransferAssetTransient>) {
    super(TRANSFER_ASSET_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





